var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-subtitle bold color--primary mt-4",class:_vm.dark ? 'color--primary-60-s' : 'color--primary'},[_vm._v(" "+_vm._s(_vm.roundTo(_vm.score, 1))+" ptos. ")]),_c('div',{staticClass:"text-big-body",class:_vm.dark ? 'color--primary-60-s' : 'color--primary'},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }